// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"798b5428","634":"871626ad","817":"417c2812"}[chunkId] + ".chunk.js";
};